"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Description = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const StyledDescription = styled_components_1.default.p `
	white-space: pre-line;
	font-size: ${({ theme, customStyle }) => { var _a, _b; return ((_b = (_a = customStyle === null || customStyle === void 0 ? void 0 : customStyle.font) === null || _a === void 0 ? void 0 : _a.body) === null || _b === void 0 ? void 0 : _b.fontSize) || theme.baseFontSize; }};
	inline-height: ${({ customStyle }) => { var _a, _b; return (_b = (_a = customStyle === null || customStyle === void 0 ? void 0 : customStyle.font) === null || _a === void 0 ? void 0 : _a.body) === null || _b === void 0 ? void 0 : _b.fontInlineHeight; }};
	text-align: ${({ customStyle }) => { var _a, _b; return ((_b = (_a = customStyle === null || customStyle === void 0 ? void 0 : customStyle.font) === null || _a === void 0 ? void 0 : _a.body) === null || _b === void 0 ? void 0 : _b.textAlign) || 'center'; }};
	letter-spacing: 0;
	color: ${({ theme, customStyle }) => { var _a, _b; return (_b = (_a = customStyle === null || customStyle === void 0 ? void 0 : customStyle.color) === null || _a === void 0 ? void 0 : _a.primary) !== null && _b !== void 0 ? _b : theme.textBlack; }};
	width: 100%; // ie-text-wrap - compatibility with IE
	margin: ${({ customStyle }) => (customStyle === null || customStyle === void 0 ? void 0 : customStyle.margin) ? customStyle === null || customStyle === void 0 ? void 0 : customStyle.margin : '20px auto'};

	display: -webkit-box;
	-webkit-line-clamp: 3; /* Show 3 lines only */
	-webkit-box-orient: vertical;
	overflow: hidden;
	transition: max-height 0.5s ease-in-out;
	max-height: calc(1.5em * 3);

	${({ customStyle }) => (`
		-webkit-line-clamp: ${!(customStyle === null || customStyle === void 0 ? void 0 : customStyle.isReadMore) ? 'unset' : '3'};
		max-height: ${!(customStyle === null || customStyle === void 0 ? void 0 : customStyle.isReadMore) ? '100%' : 'calc(1.5em * 3)'};
	`)}

	a {
		color: ${({ theme, customStyle }) => { var _a; return ((_a = customStyle === null || customStyle === void 0 ? void 0 : customStyle.color) === null || _a === void 0 ? void 0 : _a.hyperlink) || theme.denimBlue; }};
		text-decoration: none;
	}

	@media (max-width: 41em) {
		margin: 10px 20px;
		font-size: ${({ theme }) => theme.smallFontSize};
	}
`;
;
const Description = ({ children, dataTestId, dangerouslySetInnerHTML, customStyle }) => {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        dangerouslySetInnerHTML && (react_1.default.createElement(StyledDescription, { dangerouslySetInnerHTML: { __html: dangerouslySetInnerHTML }, "data-testid": dataTestId, customStyle: customStyle })),
        children && (react_1.default.createElement(StyledDescription, { customStyle: customStyle }, children))));
};
exports.Description = Description;
